/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, Controller, ErrorMessage, Input, Select, SwitchInput } from "@";
import { donateTypeOptions } from "../../lib/options";
import type { ProjectInfoSectionProps } from "./types";
import { ProjectType } from "@/features/donations/projects/types.ts";

export const ProjectInfoSection = ({
  register,
  watch,
  setValue,
  getValues,
  control,
  errors,
  show,
  categoriesOptions,
  customerCampaign,
}: ProjectInfoSectionProps) => {
  return (
    <Card title="معلومات المشروع">
      <Input
        style="mb-5"
        label="اسم المشروع"
        error={errors.name}
        disabled={!!show}
        input={register("name")}
      />

      <Input
        style="mb-1"
        label="العنوان على المنصة"
        error={errors.title}
        disabled={!!show}
        input={register("title")}
      />

      {(show || getValues("id")) && (
        <a
          className="text-sm text-purple-900 underline-offset-2 hover:underline dark:text-purple-400"
          href={getValues("websiteUrl") as string}
          target="_blank"
          rel=""
        >
          {getValues("websiteUrl") as string}
        </a>
      )}

      <Input
        rows={3}
        style="my-5"
        type="textarea"
        label="الوصف المختصر"
        star
        error={errors.shortDescription}
        disabled={!!show}
        input={register("shortDescription")}
      />

      {/* Classification  / ProjectType*/}
      <div className="mb-5 grid gap-5 md:grid-cols-1">
        <div>
          <label className="input-label">
            التصنيف
            {!show && <span className="star">*</span>}
          </label>
          <Controller
            control={control}
            name="classificationIds"
            render={({
              field: { onChange, value, ref },
            }: {
              field: { onChange: any; value: any; ref: any };
            }) => (
              <Select
                isDisabled={!!show}
                inputRef={ref}
                value={categoriesOptions.filter((c) =>
                  (value as number[])?.includes(c.value),
                )}
                placeholder=""
                onChange={(val: { value: number }[]) =>
                  onChange(val.map((c) => c.value))
                }
                options={categoriesOptions}
                isMulti
              />
            )}
          />
          <ErrorMessage
            value={(errors.classificationIds as { message?: string })?.message}
          />
        </div>

        <div>
          <label className="input-label">
            نوع التبرع
            {!show && <span className="star">*</span>}
          </label>

          <Controller
            name="projectType"
            control={control}
            defaultValue={2}
            render={({ field }: { field: any }) => {
              const projectTypeOptions = donateTypeOptions.map((o) => ({
                value: o.value,
                label: o.name,
              }));
              return (
                <Select
                  inputId="projectType"
                  name={field.name}
                  isDisabled={!!show || !!customerCampaign?.id}
                  options={projectTypeOptions}
                  value={
                    projectTypeOptions.find(
                      (o) => String(o.value) === String(field.value),
                    ) ?? null
                  }
                  onChange={(opt: { value: number } | null) => {
                    field.onChange(opt?.value ?? "");
                    setValue("projectAttributes", []);
                    setValue("allowOpenDonation", false);
                  }}
                  onBlur={field.onBlur}
                />
              );
            }}
          />
          <ErrorMessage
            value={(errors.projectType as { message?: string })?.message}
          />
        </div>
      </div>

      <Input
        style="mb-5"
        rows={3}
        type="textarea"
        label="نبذة عن المشروع"
        error={errors.summary}
        disabled={!!show}
        input={register("summary")}
      />

      {Number(watch("projectType")) === ProjectType.Grades && (
        <SwitchInput
          disabled={!!show || !!customerCampaign?.id}
          label="السماح بالتبرع المفتوح"
          checked={watch("allowOpenDonation") as boolean}
          change={(value: boolean) => setValue("allowOpenDonation", value)}
        />
      )}

      {/* MinimumOpenDonationAmount */}
      {(watch("allowOpenDonation") ||
        Number(watch("projectType")) === ProjectType.Open) &&
        Number(watch("projectType")) !== ProjectType.Deduction && (
          <div className="mt-2">
            <Input
              min={0}
              style="mb-5"
              type="number"
              disabled={!!show}
              label=" الحد الأدنى للتبرع المفتوح"
              error={errors.minimumOpenDonationAmount}
              input={register("minimumOpenDonationAmount")}
            />
          </div>
        )}
    </Card>
  );
};
